/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { customerViewInitialState } from '../../../store/customer/customerViewInitialState';
import classes from './View.module.scss';

import 'animate.css';
import CustomerDropdown from '../../shared/customer/CustomerDropdown';

import {
  BUTTON_STATE,
  CONFIGURE_VIEW,
  CUSTOMER_TYPE,
  CV_VIEW,
  DEFAULT_MAX_DATE_RANGE,
  DEFAULT_MIN_DATE_RANGE,
  FILTER_DATE_FORMAT,
  INSIGHT_TYPE,
  BOOLEAN_TRUE,
  BOOLEAN_FALSE,
  NUMBER_ZERO,
  VIEW,
} from 'constants/constants';
import { Fade } from 'react-awesome-reveal';
import {
  resetAffiliationFilters,
  resetEngagementFilters,
  resetSitePerformanceFilters,
  resetSiteUtilizationFilters,
  setActiveSectionTab,
  setAffiliationFilters,
  setAllInsightView,
  setCopayAnalyticsFilters,
  setCopayAnalyticsFiltersInitialState,
  setEcosystemOpportunityFilters,
  setEcosystemOpportunityInitailState,
  setEngagementFilters,
  setFilterInit,
  setInsightType,
  setPayerMixFilterInitailState,
  setPayerMixFilters,
  setPolicyDetailsFilters,
  setPolicyDetailsIniState,
  setProductMixFilters,
  setProductMixFiltersIntitalState,
  setSaveInsightViewBtnState,
  setSelectedCustomer,
  setSelectedInsightView,
  setSeletedView,
  setSitePerformanceFilters,
  setSiteUtilizationFilters,
} from 'store/customer/customerViewSlice';

import useDatadogRum from 'hooks/useDatadogRum';
import { isEqual } from 'lodash';
import { setCards } from 'store/customer/customerViewSlice';
import AdvanceSearch from '../../shared/customer/AdvanceSearch';
import HealthSystem from '../wrapper/HealthSystem';
import McoSystem from '../wrapper/McoSystem';

import moment from 'moment';
import {
  buildFilterPayload,
  getAccessibleFilters,
  getSelectedFilters,
} from 'utils/utils';
import Reports from './Reports';

const ViewInsights = () => {
  const dispatch = useDispatch();
  const { addAction } = useDatadogRum();
  const componentAccessList = useSelector(
    (state) => state?.Auth?.componentAccessList
  );
  const {
    advanceSearchClicked,
    selectedView,
    selectedCustomer,
    focusAccountChecked,
    focusAccountDisabled,
  } = useSelector((state) => state?.CustomerView);
  const notificationId = useRef(null);

  const [loadComponents, setLoadComponents] = useState(false);
  const selectedInsightView = useSelector(
    (state) => state?.CustomerView?.selectedInsightView
  );
  const engagementFilters = useSelector(
    (state) => state?.CustomerView?.engagementFilters
  );

  const sitePerformanceFilters = useSelector(
    (state) => state?.CustomerView?.sitePerformanceFilters
  );
  const siteUtilizationFilters = useSelector(
    (state) => state?.CustomerView?.siteUtilizationFilters
  );
  const AffiliationFilter = useSelector(
    (state) => state?.CustomerView?.affiliationsFilters
  );
  const copayAnalyticsFilters = useSelector(
    (state) => state?.CustomerView?.copayAnalyticsFilters
  );
  const productMixFilters = useSelector(
    (state) => state?.CustomerView?.productMixFilters
  );

  const payerMixFilters = useSelector(
    (state) => state.CustomerView?.payerMixFilters
  );
  const policyDetailsFilters = useSelector(
    (state) => state.CustomerView?.policyDetailsFilters
  );
  const ecosystemOpportunityFilters = useSelector(
    (state) => state.CustomerView?.ecosystemOpportunityFilters
  );

  const custInsightsBrdId = useSelector(
    (state) => state?.CustomerView?.custInsightsBrdId
  );

  const onChangeHandler = (selected) => {
    toast.dismiss(notificationId.current);
    if (selected?.label?.length > 1) {
      dispatch(setSelectedCustomer(selected));
      dispatch(setActiveSectionTab(''));
      setLoadComponents(true);
      dispatch(setSelectedInsightView({}));
      dispatch(setFilterInit());
      dispatch(setSeletedView(CUSTOMER_TYPE.get(selected.flag)));
      dispatch(setInsightType(INSIGHT_TYPE.GENERAL));
      dispatch(setCards([]));
      dispatch(setAllInsightView([]));

      addAction(
        'CUSTOMER_VIEW',
        { viewName: CUSTOMER_TYPE.get(selected.flag) },
        {
          timestamp: new Date().toISOString(),
          navigationSource: 'click-on-customer-view-icon',
          clickTarget: 'customer-view',
          page: 'customer-view-detail',
          view: CUSTOMER_TYPE.get(selected.flag),
          customerId: selected.value,
          customerName: selected.label,
        }
      );
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [selectedView, selectedCustomer]);

  // Helper function to set filters based on selectedInsightView
  const setAllFiltersFromInsightView = useCallback(
    (selectedInsightView) => {
      if (selectedInsightView?.filters?.Engagements) {
        dispatch(
          setEngagementFilters({
            ...customerViewInitialState?.engagementFilters,
            ...selectedInsightView?.filters?.Engagements,
          })
        );
      } else {
        dispatch(resetEngagementFilters());
      }
      if (selectedInsightView?.filters?.SitePerformance) {
        dispatch(
          setSitePerformanceFilters({
            ...customerViewInitialState?.sitePerformanceFilters,
            ...selectedInsightView?.filters?.SitePerformance,
          })
        );
      } else {
        dispatch(resetSitePerformanceFilters());
      }
      if (selectedInsightView?.filters?.SiteUtilization) {
        dispatch(
          setSiteUtilizationFilters({
            ...customerViewInitialState?.siteUtilizationFilters,
            ...selectedInsightView?.filters?.SiteUtilization,
          })
        );
      } else {
        dispatch(resetSiteUtilizationFilters());
      }
      if (selectedInsightView?.filters?.Affiliations) {
        dispatch(
          setAffiliationFilters({
            ...customerViewInitialState?.affiliationsFilters,
            ...selectedInsightView?.filters?.Affiliations,
          })
        );
      } else {
        dispatch(resetAffiliationFilters());
      }
      if (selectedInsightView?.filters?.CopayAnalytics) {
        dispatch(
          setCopayAnalyticsFilters({
            ...customerViewInitialState?.copayAnalyticsFilters,
            ...selectedInsightView?.filters?.CopayAnalytics,
          })
        );
      } else {
        dispatch(setCopayAnalyticsFiltersInitialState());
      }
      if (selectedInsightView?.filters?.ProductMix) {
        dispatch(
          setProductMixFilters({
            ...customerViewInitialState?.productMixFilters,
            ...selectedInsightView?.filters?.ProductMix,
          })
        );
      } else {
        dispatch(setProductMixFiltersIntitalState());
      }

      if (selectedInsightView?.filters?.PayerMix) {
        dispatch(
          setPayerMixFilters({
            ...customerViewInitialState?.payerMixFilters,
            ...selectedInsightView?.filters?.PayerMix,
          })
        );
      } else {
        dispatch(setPayerMixFilterInitailState());
      }

      if (selectedInsightView?.filters?.PolicyDetails) {
        dispatch(
          setPolicyDetailsFilters({
            ...customerViewInitialState?.policyDetailsFilters,
            ...selectedInsightView?.filters?.PolicyDetails,
          })
        );
      } else {
        dispatch(setPolicyDetailsIniState());
      }
      if (selectedInsightView?.filters?.EcosystemOpportunity) {
        dispatch(
          setEcosystemOpportunityFilters({
            ...customerViewInitialState?.ecosystemOpportunityFilters,
            ...selectedInsightView?.filters?.EcosystemOpportunity,
          })
        );
      } else {
        dispatch(setEcosystemOpportunityInitailState());
      }
    },
    [dispatch, selectedInsightView]
  );

  useEffect(() => {
    // Show section menu once view response received and filters are set
    if (selectedCustomer && selectedCustomer.label?.length > NUMBER_ZERO) {
      setLoadComponents(true);
    }
    return () => {
      dispatch(setActiveSectionTab(''));
    };
  }, [selectedCustomer?.value]);

  const isFirstLoad = useRef(BOOLEAN_TRUE);

  useEffect(() => {
    /**
     * Set and Reset Filters:
     * - On first load
     * - When adding a new view
     * - When deleting a view
     * - When duplicating a view
     * - Whenever selectedInsightView changes
     * - only set and reset filters for existing IB.
     */
    if (custInsightsBrdId) {
      setAllFiltersFromInsightView(selectedInsightView);
    }
    isFirstLoad.current = BOOLEAN_TRUE;
    // Always set save button state when insight view changes
    dispatch(setSaveInsightViewBtnState(BUTTON_STATE.DISABLED));
  }, [selectedInsightView?.Id]);

  useEffect(() => {
    // Resolved Enable/Disable Save Button based on filter changes for few second on first load issue
    if (isFirstLoad.current) {
      isFirstLoad.current = BOOLEAN_FALSE;
      dispatch(setSaveInsightViewBtnState(BUTTON_STATE.DISABLED));
      return;
    }

    const filters = {
      Engagements: engagementFilters,
      SitePerformance: sitePerformanceFilters,
      SiteUtilization: siteUtilizationFilters,
      Affiliations: AffiliationFilter,
      CopayAnalytics: copayAnalyticsFilters,
      ProductMix: productMixFilters,
      PayerMix: payerMixFilters,
      PolicyDetails: policyDetailsFilters,
      EcosystemOpportunity: ecosystemOpportunityFilters,
    };
    const initState = {
      Engagements: customerViewInitialState.engagementFilters,
      SitePerformance: customerViewInitialState.sitePerformanceFilters,
      SiteUtilization: customerViewInitialState.siteUtilizationFilters,
      Affiliations: customerViewInitialState.affiliationsFilters,
      CopayAnalytics: customerViewInitialState.copayAnalyticsFilters,
      ProductMix: customerViewInitialState.productMixFilters,
      PayerMix: customerViewInitialState.payerMixFilters,
      PolicyDetails: customerViewInitialState.policyDetailsFilters,
      EcosystemOpportunity:
        customerViewInitialState.ecosystemOpportunityFilters,
    };

    let disableSaveBtn = false;

    const selectedFilters = getSelectedFilters(
      getAccessibleFilters(filters, componentAccessList, selectedView)
    );

    let requiredSavedFilter = selectedInsightView?.filters
      ? getSelectedFilters(selectedInsightView?.filters)
      : {};

    if (
      !selectedInsightView?.filters ||
      Object.keys(selectedInsightView?.filters).length === NUMBER_ZERO
    ) {
      //if new view or there are no saved filter comapare filter state with initital state
      disableSaveBtn = isEqual(
        getSelectedFilters(buildFilterPayload(initState)),
        getSelectedFilters(buildFilterPayload(filters))
      );
    } else {
      //if saved filter and filter state not matching
      if (
        Object.keys(selectedFilters)?.length !==
        Object.keys(requiredSavedFilter)?.length
      ) {
        disableSaveBtn = false;
      } else {
        //check if there is any change in saved filter
        disableSaveBtn = isEqual(requiredSavedFilter, selectedFilters);
      }
    }

    const isHealthSystemView = CV_VIEW.HEALTH_SYSTEM_VIEW.includes(
      selectedCustomer?.flag
    );

    const savedDateFilters = selectedInsightView?.filters?.Engagements || {};
    const selectedStartDateFormatted = moment(
      engagementFilters.startDate.selectedValue
    ).format(FILTER_DATE_FORMAT);
    const selectedEndDateFormatted = moment(
      engagementFilters.endDate.selectedValue
    ).format(FILTER_DATE_FORMAT);

    const defaultStartDate = moment()
      .subtract(DEFAULT_MAX_DATE_RANGE, 'days')
      .format(FILTER_DATE_FORMAT);
    const defaultEndDate = moment()
      .subtract(DEFAULT_MIN_DATE_RANGE, 'day')
      .format(FILTER_DATE_FORMAT);

    let isEngagementDateChanged = true;

    if (isHealthSystemView) {
      const filtersStartDate = !!savedDateFilters.startDate?.selectedValue
        ? moment(savedDateFilters.startDate?.selectedValue).format(
            FILTER_DATE_FORMAT
          )
        : defaultStartDate;

      const filtersEndDate = !!savedDateFilters.endDate?.selectedValue
        ? moment(savedDateFilters.endDate?.selectedValue).format(
            FILTER_DATE_FORMAT
          )
        : defaultEndDate;

      isEngagementDateChanged =
        selectedStartDateFormatted === filtersStartDate &&
        selectedEndDateFormatted === filtersEndDate;
    }

    dispatch(
      setSaveInsightViewBtnState(disableSaveBtn && isEngagementDateChanged)
    );
  }, [
    sitePerformanceFilters,
    AffiliationFilter,
    siteUtilizationFilters,
    productMixFilters,
    payerMixFilters,
    policyDetailsFilters,
    copayAnalyticsFilters,
    engagementFilters,
    ecosystemOpportunityFilters,
  ]);
  return (
    <>
      {/* customer view filter */}
      <Row className={classes['title-container']}>
        <Row className='ps-0 pe-0'>
          <Col
            md={2}
            xs={12}
            className='d-flex align-items-center ps-0'>
            <Fade>
              <p
                className={`title__bold title__medium d-inline-block  ${classes['customer-insight-label']}`}>
                <i className='icon icon__customer-view--title'></i>
                Customer View
              </p>
            </Fade>
          </Col>
          <Col md={6}>
            <CustomerDropdown
              page={CONFIGURE_VIEW.customerView}
              viewName={VIEW.customer}
              onChangeHandler={onChangeHandler}
              focusDisabled={focusAccountDisabled}
              focusChecked={focusAccountChecked}
              isDisabled={false}
            />
          </Col>
          {CV_VIEW.HEALTH_SYSTEM_VIEW.includes(selectedCustomer?.flag) && (
            <Col
              md={4}
              className='me-0 pe-0 mt-1'>
              <Reports />
            </Col>
          )}
        </Row>
        {advanceSearchClicked[CONFIGURE_VIEW.customerView] && (
          <Row className='animate__animated animate__fadeIn search-container addCustomerView w-100'>
            <AdvanceSearch
              page={CONFIGURE_VIEW.customerView}
              viewType={CONFIGURE_VIEW.customerView}
            />
          </Row>
        )}
      </Row>
      {/* sections */}
      {CV_VIEW.HEALTH_SYSTEM_VIEW.includes(selectedCustomer?.flag) &&
        loadComponents && (
          <HealthSystem
            selectedView={selectedView}
            componentAccessList={componentAccessList}
          />
        )}

      {CV_VIEW.PAYER_SYSTEM_VIEW.includes(selectedCustomer?.flag) &&
        loadComponents && (
          <McoSystem
            selectedView={selectedView}
            componentAccessList={componentAccessList}
          />
        )}
    </>
  );
};

export default ViewInsights;
